module.exports = __webpack_public_path__ + "static/media/plane.0084f9ba.png";